import React, { useState, useEffect } from "react";
import EditModalGallery from "../EditModalGallery";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { supabase } from "../../supabase/supabaseClient";

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#f3f4f6" : "white",
  padding: 8,
  borderRadius: 4,
});

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  padding: 16,
  margin: `0 0 8px 0`,
  background: isDragging ? "#f9fafb" : "white",
  borderRadius: 4,
  border: "1px solid #e5e7eb",
  ...draggableStyle,
});

export default function TableTwo() {
  const [isOpen, setisOpen] = useState(false);
  const [label, setlabel] = useState("");
  const [packageData, setPackageData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await supabase
        .from("gallery")
        .select("*")
        .order("sortorder", { ascending: true });
      if (res) {
        // Preload images
        res.data.forEach((item) => {
          if (item.type.search("image") >= 0) {
            const img = new Image();
            img.src = item.public_url;
          }
        });
        setPackageData(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const items = Array.from(packageData);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setPackageData(items);

    try {
      for (let i = 0; i < items.length; i++) {
        await supabase
          .from("gallery")
          .update({ sortorder: i })
          .eq("id", items[i].id);
      }
    } catch (error) {
      console.error("Error updating order:", error);
      fetchData();
    }
  };

  const addUnitData = () => {
    setisOpen(!isOpen);
    setlabel("Add Media");
  };

  return (
    <div className="w-full max-w-[1200px] mx-auto">
      <div className="bg-white rounded-lg shadow">
        {/* Header */}
        <div className="grid grid-cols-4 gap-4 p-4 font-medium text-black border-b-2 border-black">
          <div>Order</div>
          <div>Description</div>
          <div>Image</div>
          <div className="text-center">Actions</div>
        </div>

        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={getListStyle(snapshot.isDraggingOver)}
              >
                {packageData.map((packageItem, index) => (
                  <Draggable
                    key={packageItem.id.toString()}
                    draggableId={packageItem.id.toString()}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <div className="grid grid-cols-4 gap-4 items-center">
                          <div>
                            <div
                              {...provided.dragHandleProps}
                              className="flex items-center gap-2 cursor-move"
                            >
                              <svg
                                className="w-6 h-6 text-gray-500"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M4 8h16M4 16h16"
                                ></path>
                              </svg>
                              <span>{index + 1}</span>
                            </div>
                          </div>
                          <div className="text-black">
                            {packageItem.fileName}
                          </div>
                          <div>
                            {packageItem.type.search("image") >= 0 ? (
                              <img
                                src={packageItem.public_url}
                                className="w-16 h-16 object-cover"
                                alt={packageItem.fileName}
                                loading="eager"
                                decoding="sync"
                                fetchPriority="high"
                              />
                            ) : (
                              <video
                                controls
                                className="w-16 h-16"
                                preload="metadata"
                              >
                                <source
                                  src={packageItem.public_url}
                                  type={packageItem.type}
                                />
                                your browser does not support the video tag
                              </video>
                            )}
                          </div>
                          <div className="flex justify-center">
                            <button
                              onClick={async () => {
                                const { error } = await supabase
                                  .from("gallery")
                                  .delete()
                                  .eq("id", packageItem.id);
                                if (!error) {
                                  fetchData();
                                }
                              }}
                              className="hover:text-primary"
                            >
                              <svg
                                className="fill-current"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="black"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M13.7535 2.47502H11.5879V1.9969C11.5879 1.15315 10.9129 0.478149 10.0691 0.478149H7.90352C7.05977 0.478149 6.38477 1.15315 6.38477 1.9969V2.47502H4.21914C3.40352 2.47502 2.72852 3.15002 2.72852 3.96565V4.8094C2.72852 5.42815 3.09414 5.9344 3.62852 6.1594L4.07852 15.4688C4.13477 16.6219 5.09102 17.5219 6.24414 17.5219H11.7004C12.8535 17.5219 13.8098 16.6219 13.866 15.4688L14.3441 6.13127C14.8785 5.90627 15.2441 5.3719 15.2441 4.78127V3.93752C15.2441 3.15002 14.5691 2.47502 13.7535 2.47502ZM7.67852 1.9969C7.67852 1.85627 7.79102 1.74377 7.93164 1.74377H10.0973C10.2379 1.74377 10.3504 1.85627 10.3504 1.9969V2.47502H7.70664V1.9969H7.67852ZM4.02227 3.96565C4.02227 3.85315 4.10664 3.74065 4.24727 3.74065H13.7535C13.866 3.74065 13.9785 3.82502 13.9785 3.96565V4.8094C13.9785 4.9219 13.8941 5.0344 13.7535 5.0344H4.24727C4.13477 5.0344 4.02227 4.95002 4.02227 4.8094V3.96565ZM11.7285 16.2563H6.27227C5.79414 16.2563 5.40039 15.8906 5.37227 15.3844L4.95039 6.2719H13.0785L12.6566 15.3844C12.6004 15.8625 12.2066 16.2563 11.7285 16.2563Z" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      <div className="flex justify-center mt-8 mb-20">
        <button
          onClick={addUnitData}
          className="inline-flex items-center justify-center rounded-md bg-[#ad885d] py-3 px-8 text-center font-medium text-white hover:bg-opacity-90"
        >
          Add Media
        </button>
      </div>

      <EditModalGallery Open={isOpen} label={label} fetchData={fetchData} />
    </div>
  );
}
